import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.some.js";
import Vue from "vue";
import VueRouter from "vue-router";
import { Message } from "view-design";
import _ from "lodash";
import routes from "./routes";
import { getLogin, noAuth } from "../libs/auth";
import store from "../store";
import { auth } from "@/service/cas";
import { getWXCode, getUUID, hasHttp, getRedirect } from "@/libs/url";
import { wxLogin } from "@/service/wx";
import { dingLogin } from "@/service/ding";
import { findRouterForPath } from "@/libs/watermark";
import { getMobileLoginDestination } from "@/utils/login-destination";
import { isMobileJs, getBrowerLang } from "@/utils/util";
import { getLocalWx, clearLocalWx } from "@/libs/auth";
import { refreshI18nAuthInfo } from "../../lang";
Vue.use(VueRouter);
const router = new VueRouter({
  mode: "history",
  routes
  // 禁止浏览器回退
  // scrollBehavior: () => {
  //   history.pushState(null, null, document.URL);
  // },
});
// 路由重复跳转时捕获错误信息 ===> 添加如下的代码
const VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err);
};
const normalizeRoutePath = (path = "") => {
  const normalizedPath = String(path || "").replace(/\/+$/, "").toLowerCase();
  return normalizedPath || "/";
};
const hasVisibleAppCode = (code, apps = []) => {
  return apps.some(app => {
    if (!app) return false;
    if (app.code === code) return true;
    return Array.isArray(app.apps) && hasVisibleAppCode(code, app.apps);
  });
};
const getPermissionDeniedRedirect = (userInfo = {}, to, from) => {
  const previousPath = normalizeRoutePath(from === null || from === void 0 ? void 0 : from.path);
  const targetPath = normalizeRoutePath(to === null || to === void 0 ? void 0 : to.path);
  if (previousPath && previousPath !== "/" && previousPath !== targetPath) {
    return from.fullPath || from.path;
  }
  if (userInfo !== null && userInfo !== void 0 && userInfo.unitId) {
    return (userInfo === null || userInfo === void 0 ? void 0 : userInfo.isAdmin) === "T" ? "/MGT" : "/MGT/member";
  }
  return "/MGT/communicationUser";
};
const shouldFallbackWorkbenchAfterUnitSelect = (from, userInfo = {}) => {
  // 仅“登录/选单位页 -> 无权限目标路由”这一跳转场景回退工作台；
  // 已登录用户后续手输无权限路由仍按原逻辑提示“权限不足”并拦截。
  return normalizeRoutePath(from === null || from === void 0 ? void 0 : from.path) === "/login" && Boolean(userInfo === null || userInfo === void 0 ? void 0 : userInfo.unitId);
};

// 菜单隐藏只是入口控制；这里补上路由级权限守卫，拦住手输地址访问管理员页面的情况。
const hasRoutePermission = (to, userInfo = {}, visibleApps = []) => {
  var _to$meta, _to$meta2;
  const requireAdmin = Boolean((_to$meta = to.meta) === null || _to$meta === void 0 ? void 0 : _to$meta.requireAdmin);
  if (requireAdmin && !(userInfo !== null && userInfo !== void 0 && userInfo.unitId && (userInfo === null || userInfo === void 0 ? void 0 : userInfo.isAdmin) === "T")) {
    return false;
  }
  const requiredAppCode = (_to$meta2 = to.meta) === null || _to$meta2 === void 0 ? void 0 : _to$meta2.requireVisibleAppCode;
  if (requiredAppCode && !hasVisibleAppCode(requiredAppCode, visibleApps)) {
    return false;
  }
  return true;
};
// 微信直接登录，不需要二确认
async function wxFastLogin(wx, uuid, next) {
  let redirect = wx.redirect || "";
  clearLocalWx();
  const res = await wxLogin({
    uuid,
    mode: "LOGIN_CONFIRM"
  });
  if (res.data.result === 0) {
    if (res.data.retVal.status === "SCAN_CONFIRM") {
      await store.commit("setLogin", true);
      next({
        path: "login",
        query: {
          redirect
        },
        replace: true
      });
    } else {
      this.$Message.error({
        content: res.data.msg
      });
    }
  }
}
router.beforeEach(async (to, from, next) => {
  if (to.query.mobile) {
    to.query.mobile = to.query.mobile.replace(/\s/g, "+");
  }
  const languageType = {
    en: "en-US",
    zh: "zh-CN",
    "en-US": "en-US",
    "zh-cn": "zh-CN",
    "zh-tw": "zh-TW",
    "zh-CN": "zh-CN",
    "zh-TW": "zh-TW",
    "zh-HK": "zh-TW"
  };
  //判断参数里有没有语言
  const {
    language
  } = to.query;
  if (language) {
    //todo 语言设置 暂时注释
    // i18n.locale = languageType[language] || getBrowerLang();
    store.commit("setLanguage", languageType[language] || getBrowerLang());
  }
  // 添加水印控制
  findRouterForPath();
  const state = getUUID(to);
  const code = getWXCode(to);
  const isDing = _.includes(state, "ding");
  if (isDing) {
    const res = await dingLogin({
      code,
      state
    });
    if (res.data.result === 0) {
      await store.commit("setLogin", true);
      // 如果有跳转的 跳转
      const redirect = getRedirect(location.search, location.hash);
      if (hasHttp(redirect)) {
        //外部链接 带上ticket

        const res = await auth(redirect);
        //拼接url
        if (res && res.data && res.data.result === 0) {
          location.href = res.data.retVal;
        }
      } else {
        next({
          path: "/MGT",
          replace: true
        });
      }
    } else {
      this.$Message.error({
        content: $t("htkbge8", "请联系管理员绑定")
      });
      next({
        path: "login",
        replace: true
      });
    }
  } else {
    if (_.has(to.query, "client_id")) {
      next();
    } else if (state) {
      // authCode以后首次登录成功后，相同authCode再次登录无效,则跳回登录页面
      if (localStorage.getItem("wx_auth_code") === code) {
        next({
          path: "login",
          replace: true
        });
      } else {
        const res = await wxLogin({
          uuid: state,
          authCode: code,
          mode: "LOGIN"
        });
        let query = _.omit(_.omit(to.query, "code"), "state");
        // 微信直接登录
        let wx = getLocalWx();
        // authCode以后首次登录成功后，相同authCode再次登录无效（本地缓存）
        localStorage.setItem("wx_auth_code", code);
        // 移动端成功响应的 destination 优先于微信快捷登录确认及选单位。
        const destination = getMobileLoginDestination(res.data, isMobileJs());
        if (destination) {
          store.commit("setLogin", true);
          window.location.href = destination;
          return;
        }
        if (wx.login === "T" && res.data.result === 0 && res.data.retVal.openId === "BIND_OPENID") {
          wxFastLogin(wx, state, next);
        } else {
          if (res.data.result === 0) {
            if (res.data.retVal.destination) {
              // 如果有强制跳转的 跳转到这个地方
              window.location.href = res.data.retVal.destination;
            } else {
              const {
                openId,
                title
              } = res.data.retVal;
              if (openId === "BIND_OPENID") {
                next({
                  name: "Success",
                  query: {
                    uuid: state,
                    title
                  },
                  replace: true
                });
              } else if (openId === "UN_BIND_OPENID") {
                next({
                  name: "Regist",
                  query: {
                    uuid: state
                  },
                  replace: true
                });
              } else {
                next({
                  name: "Login",
                  query,
                  replace: true
                });
              }
            }
          } else {
            next({
              name: "Login",
              query,
              replace: true
            });
          }
        }
      }
    } else {
      if (noAuth(to)) {
        next();
      } else {
        //如果登录了 去验证
        if (getLogin()) {
          if (!_.has(to.meta, "auth")) {
            if (!store.state.user.userInfo.userId) {
              // 登录态刷新时并行恢复用户信息和翻译身份，二者互不依赖。
              await Promise.all([store.dispatch("getUserInfo"), refreshI18nAuthInfo().catch(() => false)]);
            }
          }
          if (!hasRoutePermission(to, store.state.user.userInfo, store.state.user.visibleApps)) {
            if (shouldFallbackWorkbenchAfterUnitSelect(from, store.state.user.userInfo)) {
              next({
                path: "/MGT",
                replace: true
              });
              return;
            }
            Message.error({
              content: $t("dna1kj4", "权限不足")
            });
            next({
              path: getPermissionDeniedRedirect(store.state.user.userInfo, to, from),
              replace: true
            });
            return;
          }
          next();
        } else {
          const toQuery = to.query;
          const query = {
            redirect: to.path,
            ...toQuery
          };
          next({
            name: "Login",
            query
          });
        }
      }
    }
  }
});
export default router;